












































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, PropSync, Emit, Watch } from 'vue-property-decorator';

@Component
export default class DirectoryItem extends Vue {
    @Prop()
    height!: number;

    @Prop({ required: true })
    directoryInfo!: {
        id: number;
        name: string;
        show: boolean;
        adminUser: boolean;
    };
    buttonRipple: boolean = false;
    contactSearch: string = '';
    loadingContacts: boolean = true;

    @PropSync('isSelected', {
        default: false,
    })
    isSelectedProp!: boolean;

    @Emit('emitContact')
    emitContact(contact: any) {
        this.$emit('contactClicked', contact);
    }

    get directoryItem() {
        return this.directoryInfo;
    }

    filterByContact(contactName: string): boolean {
        if (this.contactSearch != '') {
            if (contactName.toUpperCase().includes(this.contactSearch.toUpperCase())) {
                return true;
            } else {
                return contactName
                    .toUpperCase()
                    .normalize('NFD')
                    .replace(/[\u0300-\u036f]/g, '')
                    .includes(this.contactSearch.toUpperCase());
            }
        } else {
            return true;
        }
    }

    filterIndexByContact(directoryItem: any): boolean {
        if (this.contactSearch != '') {
            let show: boolean = false;
            directoryItem.contacts.forEach((c: any) => {
                if (
                    this.filterByContact(c.name.split(', ')[0]) ||
                    this.filterByContact(c.name.split(', ')[1])
                ) {
                    show = true;
                }
            });
            return show;
        } else {
            return true;
        }
    }
}
